import React, { useMemo } from 'react';
import useProjectId from './useProjectId';
import useIntegrationModuleFinder from './useIntegrationModuleFinder';
import useCustomizedModuleFinder from './useCustomizedModuleFinder';
import { addProtocolToLink } from '@utils/common';
import { INTEGRATION_TYPES } from '@model';

function useCustomizedModuleData(
  moduleValue,
  integrationModuleId,
  addHttp = true,
) {
  const projectId = useProjectId();
  const { targetModule: integrationModule, integrationModuleData } =
    useIntegrationModuleFinder(projectId, integrationModuleId);
  const customizeModule = useCustomizedModuleFinder(moduleValue);

  const targetModuleData = useMemo(() => {
    let targetModule;
    if (integrationModuleId && integrationModule) {
      targetModule = integrationModule;
    }
    if (moduleValue && customizeModule) {
      targetModule = customizeModule;
    }

    const rawLink = targetModule?.link || '';
    const shouldAddHttp =
      addHttp && targetModule?.type !== INTEGRATION_TYPES.HTML;

    return {
      link: shouldAddHttp ? addProtocolToLink(rawLink) : rawLink,
      moduleName: targetModule?.module,
      ratio: targetModule?.ratio,
      spnId: targetModule?.spnId || null,
      type: targetModule?.type,
    };
  }, [integrationModule, customizeModule, addHttp]);

  return {
    integrationModuleData,
    targetModuleData,
  };
}

export default useCustomizedModuleData;
